import(/* webpackMode: "eager" */ "/app/apps/backend/src/app/global-error.tsx");
